import { MutableRef, useContext, useEffect } from 'preact/hooks'
import BaseContext from 'contexts/base-context'
import { getFieldDomByCode } from 'components/business/SurveyForm/Fields/utils'
import { scrollTo, showFullChildElement } from 'scripts/utils'

export default function useScrollProps(scrollAreaRef: MutableRef<HTMLDivElement>) {
  const { editingCode } = useContext(BaseContext)

  useEffect(() => {
    if (editingCode && scrollAreaRef.current) {
      const editFieldDom = getFieldDomByCode(editingCode)
      if (editFieldDom) {
        showFullChildElement(editFieldDom)
      }
    }
  }, [editingCode])

  const scrollToFieldPositionByCode = (code: string) => {
    const targetNode = getFieldDomByCode(code)
    if (scrollAreaRef.current && targetNode) {
      scrollTo(scrollAreaRef.current, targetNode.offsetTop).then()
    }
  }

  return {
    scrollToFieldPositionByCode,
  }
}
